import React from "react";
import Criteria from "./Criteria";

export default class UserAgent extends React.Component {
  constructor(props, context) {
    super(props, context);

    if (props.criteria.conditions === undefined) {
      props.criteria.conditions = { expression: "" };
    }

    this.state = {
      criteria: props.criteria,
    };

    /*{type: "application.http.useragent.regex", negate: false, conditions: {expression:""}}*/
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.criteria.conditions === undefined) {
      nextprops.criteria.conditions = { expression: "" };
    }

    this.setState({
      criteria: nextprops.criteria,
    });
  }

  handle_ChangeExpression = (event) => {
    this.state.criteria.conditions.expression = event.target.value;
    this.bubble_Changes(this.state.criteria);
  };

  bubble_Changes = (criteria) => {
    /* Push changes up to the root */
    this.props.bubbleMethod(criteria);
  };

  render() {
    return (
      <Criteria label="User Agent Regex" onRemove={() => this.props.handle_RemoveCriteria(this.state.criteria)}>
        <div className="mui-textfield">
          <input
            type="text"
            onChange={this.handle_ChangeExpression}
            value={this.state.criteria.conditions["expression"]}
            placeholder="User Agent Regex"
          />
        </div>
      </Criteria>
    );
  }
}
